module.exports = __webpack_public_path__ + "static/logo-4173954280114b852c2cd10fabd39bf2.png";